import { CardinalOrientation } from 'walktour'

export const ONBOARDING_STEP_INDEXES = {
  ACTION: 0,
  CHECKBOX: 1,
  SET_PENILAIAN: 2,
  SEND_PENILAIAN: 3,
}

export const TABLE_ID = 'table-pegawai-penetapan'
export const NUMBER_OF_EMPLOYEES_ID = 'number-pegawai-penetapan'
export const OPEN_FORM_BTN_ID = 'btn-berikan-penilaian'
export const NOTIFICATION_ID = 'toolbar-notification'
export const FORM_ID = 'form-pegawai-penetapan'
export const FOOTER_ID = 'footer-pegawai-penetapan'
export const SEND_PENILAIAN_ID = 'sent-penetapan'
export const ACTION_CLASSES = 'action-penetapan'
export const CHECKBOX_CLASSES = 'checkbox-penetapan'

export const STEP_IDS = {
  TABLE_ID,
  NUMBER_OF_EMPLOYEES_ID,
  OPEN_FORM_BTN_ID,
  NOTIFICATION_ID,
  FORM_ID,
  FOOTER_ID,
  SEND_PENILAIAN_ID,
  ACTION_CLASSES,
  CHECKBOX_CLASSES,
}

export const STEPS = [
  {
    selector: `#${TABLE_ID} tbody tr td:last-of-type`,
    maskSelector: `.${ACTION_CLASSES}`,
    description:
      'Klik tombol ini untuk melakukan Rekomendasi Predikat Kinerja dan melihat data yang perlu Anda pertimbangkan.',
    orientationPreferences: [CardinalOrientation.WEST],
  },
  {
    selector: `#${TABLE_ID} tbody tr td:first-of-type`,
    maskSelector: `.${CHECKBOX_CLASSES}`,
    description: 'Klik kotak ini untuk memilih banyak nama Pengawas Sekolah.',
    orientationPreferences: [CardinalOrientation.EAST],
  },
  {
    selector: `#${OPEN_FORM_BTN_ID}`,
    maskSelector: `#${FOOTER_ID}`,
    description:
      'Klik tombol ini untuk melakukan Rekomendasi Predikat Kinerja terhadap banyak Pengawas Sekolah yang sudah Anda pilih.',
    orientationPreferences: [CardinalOrientation.NORTH],
    tooltipSeparation: 50,
  },
  {
    selector: `#${SEND_PENILAIAN_ID}`,
    maskSelector: `#${FOOTER_ID}`,
    description:
      'Klik tombol ini untuk kirim data Rekomendasi Predikat Kinerja ke Pejabat Penilai Kinerja.',
    orientationPreferences: [CardinalOrientation.NORTH],
    tooltipSeparation: 50,
  },
]
